// lightbox-zoom.js
(function () {
  // Config: selector that matches your product thumbnails (adjust if needed)
  const THUMB_SELECTOR = '.pz-thumb'; // change to match your product gallery image elements

  // Create overlay elements
  const overlay = document.createElement('div');
  overlay.className = 'pz-overlay';
  overlay.setAttribute('aria-hidden','true');

  const inner = document.createElement('div');
  inner.className = 'pz-inner';

  const img = document.createElement('img');
  img.className = 'pz-img';
  img.alt = '';

  inner.appendChild(img);
  overlay.appendChild(inner);

  const closeBtn = document.createElement('button');
  closeBtn.className = 'pz-close';
  closeBtn.innerHTML = '✕';
  closeBtn.setAttribute('aria-label','Close image');

  const caption = document.createElement('div');
  caption.className = 'pz-caption';

  document.body.appendChild(overlay);
  document.body.appendChild(closeBtn);
  document.body.appendChild(caption);

  // Transform state
  let scale = 1;
  let minScale = 1;
  let maxScale = 4;
  let originX = 0, originY = 0;
  let translateX = 0, translateY = 0;
  let isDragging = false;
  let dragStart = {x:0,y:0};
  let imgNaturalWidth = 0, imgNaturalHeight = 0;

  function setTransform() {
    img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
  }

  function open(src, alt) {
    img.src = src;
    img.alt = alt || '';
    caption.textContent = alt || '';
    overlay.classList.add('open');
    closeBtn.style.display = 'block';
    overlay.setAttribute('aria-hidden','false');
    scale = 1;
    translateX = 0;
    translateY = 0;
    setTransform();
    // read natural size to calculate bounds
    img.onload = () => {
      imgNaturalWidth = img.naturalWidth;
      imgNaturalHeight = img.naturalHeight;
      // set minScale so image fits inside inner
      const ratioW = inner.clientWidth / imgNaturalWidth;
      const ratioH = inner.clientHeight / imgNaturalHeight;
      minScale = Math.min(1, Math.min(ratioW, ratioH));
      if (minScale <= 0) minScale = 1;
      scale = minScale;
      setTransform();
    };
    // focus for keyboard
    setTimeout(()=> closeBtn.focus(), 50);
  }

  function close() {
    overlay.classList.remove('open');
    closeBtn.style.display = 'none';
    overlay.setAttribute('aria-hidden','true');
    scale = 1; translateX = 0; translateY = 0;
    img.src = '';
    caption.textContent = '';
  }

  // Attach click to thumbs (supports dynamic content by delegating)
  document.addEventListener('click', function(e){
    const thumb = e.target.closest(THUMB_SELECTOR);
    if (!thumb) return;
    e.preventDefault();
    // detect the image source - try data-large, src, data-srcset
    let large = thumb.dataset.large || thumb.dataset.src || thumb.getAttribute('href') || thumb.src || thumb.querySelector && thumb.querySelector('img') && thumb.querySelector('img').src;
    if (!large) {
      // fallback: if <img> inside, use src
      const imgEl = thumb.querySelector && thumb.querySelector('img');
      if (imgEl) large = imgEl.src;
    }
    const alt = (thumb.alt || (thumb.querySelector && thumb.querySelector('img') && thumb.querySelector('img').alt) || '');
    if (large) open(large, alt);
  });

  // Close handlers
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') close();
  });

  // Wheel for zoom (desktop)
  overlay.addEventListener('wheel', function(e){
    if (!overlay.classList.contains('open')) return;
    e.preventDefault();
    // wheel up = zoom in
    const delta = -e.deltaY || e.wheelDelta || -e.detail;
    const zoomFactor = delta > 0 ? 1.12 : 0.88;
    const rect = img.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;
    // convert to image coords
    const imgX = (offsetX - translateX) / scale;
    const imgY = (offsetY - translateY) / scale;
    const newScale = Math.max(minScale, Math.min(maxScale, scale * zoomFactor));
    // update translate so the point under the cursor remains
    translateX = offsetX - imgX * newScale;
    translateY = offsetY - imgY * newScale;
    scale = newScale;
    setTransform();
  }, {passive:false});

  // Drag to pan
  inner.addEventListener('mousedown', function(e){
    if (!overlay.classList.contains('open')) return;
    if (scale <= minScale + 0.001) return; // only pan if zoomed
    isDragging = true;
    inner.style.cursor = 'grabbing';
    dragStart.x = e.clientX - translateX;
    dragStart.y = e.clientY - translateY;
    e.preventDefault();
  });
  window.addEventListener('mousemove', function(e){
    if (!isDragging) return;
    translateX = e.clientX - dragStart.x;
    translateY = e.clientY - dragStart.y;
    setTransform();
  });
  window.addEventListener('mouseup', function(){
    if (!isDragging) return;
    isDragging = false;
    inner.style.cursor = 'grab';
  });

  // Touch: pinch to zoom basic + pan
  let lastTouchDist = null;
  let lastTouchCenter = null;
  overlay.addEventListener('touchstart', function(e){
    if (e.touches.length === 2) {
      lastTouchDist = getDist(e.touches[0], e.touches[1]);
      lastTouchCenter = getCenter(e.touches[0], e.touches[1]);
    } else if (e.touches.length === 1) {
      // single finger pan start
      dragStart.x = e.touches[0].clientX - translateX;
      dragStart.y = e.touches[0].clientY - translateY;
    }
  }, {passive:false});

  overlay.addEventListener('touchmove', function(e){
    if (e.touches.length === 2) {
      e.preventDefault();
      const d = getDist(e.touches[0], e.touches[1]);
      const center = getCenter(e.touches[0], e.touches[1]);
      const zoomFactor = d / (lastTouchDist || d);
      const rect = img.getBoundingClientRect();
      const offsetX = center.x - rect.left;
      const offsetY = center.y - rect.top;
      const imgX = (offsetX - translateX) / scale;
      const imgY = (offsetY - translateY) / scale;
      const newScale = Math.max(minScale, Math.min(maxScale, scale * zoomFactor));
      translateX = offsetX - imgX * newScale;
      translateY = offsetY - imgY * newScale;
      scale = newScale;
      lastTouchDist = d;
      setTransform();
    } else if (e.touches.length === 1 && scale > minScale + 0.001) {
      e.preventDefault();
      translateX = e.touches[0].clientX - dragStart.x;
      translateY = e.touches[0].clientY - dragStart.y;
      setTransform();
    }
  }, {passive:false});

  overlay.addEventListener('touchend', function(e){
    if (e.touches.length < 2) lastTouchDist = null;
  });

  function getDist(a,b){
    const dx = a.clientX - b.clientX;
    const dy = a.clientY - b.clientY;
    return Math.sqrt(dx*dx + dy*dy);
  }
  function getCenter(a,b){
    return { x: (a.clientX+b.clientX)/2, y: (a.clientY+b.clientY)/2 };
  }

  // Helpful: open when user double-clicks image to zoom quickly
  overlay.addEventListener('dblclick', function(e){
    if (!overlay.classList.contains('open')) return;
    if (scale <= minScale + 0.001) {
      scale = Math.min(maxScale, minScale * 2.5);
    } else {
      scale = minScale;
      translateX = 0; translateY = 0;
    }
    setTransform();
  });

  // expose (optional) to window for debugging
  window._pz_open = open;
  window._pz_close = close;
})();
